import React from 'react';
import classNames from 'classnames';
import { Trans } from '@lingui/macro';
import { Link } from '@reach/router';
import { linkTo } from 'utils/links';

import Image from 'components/Image';
import Panel from 'components/Panel';

const imageStyles = { width: 90, height: 90 };

export default function Artist({ artist, className }) {
  return (
    <div className={className}>
      <Link to={linkTo('/members/profiles/:slug', artist)}>
        <Panel type="primary">
          <div className="flex flex-col items-center overflow-hidden">
            <h2 className="text-lg text-default font-sans mb-4 truncate">{artist.name}</h2>
            <Image src={artist.image} className="mb-8 rounded-full border-4 border-neutral bg-neutral" style={imageStyles} />
            <p title={artist.country} className={classNames('w-full text-center text-secondary truncate', {
              'mb-10 xl:mb-16': !!artist.stats,
            })}>{artist.country}</p>
          </div>
          {artist.stats &&
            <div className="flex">
              <div className="flex-1 text-secondary font-sans text-center">
                <p className="text-lg leading-tight">{artist.stats.albums} <small className="block text-sm"><Trans>Albums</Trans></small></p>
              </div>
              <div className="flex-1 text-secondary font-sans text-center">
                <p className="text-lg leading-tight">{artist.stats.songs} <small className="block text-sm"><Trans>Songs</Trans></small></p>
              </div>
              <div className="flex-1 text-secondary font-sans text-center">
                <p className="text-lg leading-tight">{artist.stats.plays} <small className="block text-sm"><Trans>Plays</Trans></small></p>
              </div>
            </div>
          }
        </Panel>
      </Link>
    </div>
  );
}
